import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';
import { ChangeStep } from '../../redux/actions/StepperAction';
import { BpCheckbox, InputError, notify } from '../../utils';
import { useState } from 'react';
import { acceptRule, newCertificate } from '../../../api/MoadianService';
import { setStatus, setTransaction } from '../../redux/actions/TokneAction';
import {useMediaQuery, useTheme} from "@mui/material";

export default function NewCertModal({setOpenModal}) {
    const dispatch = useDispatch();
    const[accept, setAccept] = useState(false);
    const[error, setError] = useState("");
    const tokenInfo = useSelector(state => state.Token);
    const rules = [
        "استفاده از درگاه اینترنتی گواهیت (www.govahit.ir) به منزله قبول و تعهد به رعایت قوانین زیر است و در صورت عدم رعایت قوانین، این درگاه حق محدودیت یا قطع دسترسی کاربر را دارد.",
        "این گواهی برای ثبت نام و بارگذاری فاکتور در سامانه مودیان سازمان امور مالیاتی قابل استفاده است.",
        "گواهی دیجیتال صادره فقط برای اهداف مالیاتی و در چارچوب قوانین مالیاتی کشور استفاده می‌شود. هرگونه استفاده غیرمجاز از گواهی دیجیتال ممنوع است و پیگرد قانونی خواهد داشت.",
        "این گواهی برای شخص کاربر یا سازمانی که کاربر به عنوان نماینده آن معرفی شده است، صادر شده است. کاربر به هیچ عنوان حق انتقال آن بصورت جزئی یا کلی به دیگران را ندارد.",
        "کاربر متعهد به نگهداری امن اطلاعات حساب کاربری و عدم افشای آن است.",
        "کاربر مسئولیت کامل حفظ و نگهداری کلید خصوصی خود را بر عهده دارد.",
        "درگاه اینترنتی هیچ مسئولیتی در قبال از دست رفتن یا سوءاستفاده از کلید خصوصی کاربر ندارد.",
        "کاربر موظف به پرداخت هزینه‌های مربوط به صدور گواهی دیجیتال و خدمات مرتبط با آن است.",
        "پرداخت‌ها باید صرفاً از طریق درگاه پرداخت موجود در درگاه اینترنتی گواهیت انجام شوند و هرگونه پرداخت خارج از این چارچوب بی اعتبار خواهد بود.",
        "درگاه اینترنتی گواهیت متعهد به حفظ امنیت و حریم خصوصی اطلاعات کاربران است.",
        "انصراف از ادامه روند اخذ گواهی و عودت وجه قبل از صدور گواهی امکان پذیر است و پس از آن امکان انصراف و عودت وجه وجود ندارد. تا قبل از مرحله صدور گواهی در هر مرحله از فرایند که کاربر انصراف دهد، هزینه احتمالی مراحل باقیمانده قابل بازپرداخت خواهد بود و هزینه مراحل گذشته غیرقابل بازگشت است.",
        "درگاه اینترنتی گواهیت حق تغییر و بروزرسانی قوانین کاربری خود را در هر زمان برای خود محفوظ می‌داند. و کاربران موظف به مطالعه و رعایت آخرین نسخه قوانین منتشر شده در درگاه اینترنتی هستند.",
        "در صورت نیاز به اطلاعات بیشتر با شماره 02191014648 داخلی 404 و 401 یا شماره همراه 09329640013 تماس حاصل فرمایید.",
    ]

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    
    const [isSubmitted, setIsSubmitted] = useState(false)

    function AccpetRule() {
        setIsSubmitted(true)
        if(accept) {

            newCertificate(tokenInfo.transactionId).then(response => {

                dispatch(setStatus({status: response.data.status}))
                dispatch(setTransaction({transactionId: response.data.transactionId}))
                
                acceptRule(response.data.transactionId)
                .then( response => {
                    setError('')
                    dispatch(ChangeStep(0))
                })
                .catch(error => {
                    console.error(error.response.data.message)
                    setIsSubmitted(false)
                    setError(error.response.data.message)
                })
                
                setIsSubmitted(false)
    
            }).catch(error => {
                setIsSubmitted(false)
                notify(error.response.data.message)
            })

        }else{
            setIsSubmitted(false)
            setError("لطفا قوانین را تایید کنید")
        }
    }

    const style = (theme) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 2,
        borderRadius: '10px',
        [theme.breakpoints.down('md')]: {
            width: "100%",
        },
    }) 

    return(
        <Box sx={style } className="rule-width py-4 px-3">
            <div>
                <p className="header-text mt-1" style={{"color" : "black", "lineHeight" : "normal"}}>صدور مجدد گواهی</p>
                <p className="text-format" style={{"color": "#212121"}}>آیا می‌خواهید گواهی جدید دریافت کنید؟</p>
                <p className="text-format" style={{"color": "#FF2B2B"}}><span style={{"fontWeight": "700"}}>توجه:</span> شما در حال حاضر گواهی معتبر دارید و در صورت دریافت گواهی جدید، گواهی قبلی شما ابطال خواهد شد و کلیدهای آن دیگر اعتبار ندارد.</p>
            </div>
            
            <div className='rounded p-3 m-md-3 mt-2 rule-modal-new-cert ltr'>

                <div className='rtl'>

                    {
                        rules.map((row, index) => (
                            <div className='text-format-rule my-2'>
                                <span style={{"color": "#0BA9B5", fontWeight: "500"}}>{index + 1} - </span>
                                <span>{row}</span>
                            </div>
                        ))
                    }

                </div>


            </div>

            <div className='mx-2'>
                <BpCheckbox name="accept-rule" id="accept-rule" onClick={(e) => setAccept(e.target.checked)} />
                <label  className="text-format" style={{"color": "#4D4D4D"}}>قوانین را مطالعه کرده و می<span>&#8202;</span>پذیرم</label>
                <div className='m-0 me-3 mb-2'>
                    {error && <InputError message={error} />}
                </div>
                
            </div>



            <div className='row justify-content-center w-100 m-0 pe-md-5'>

                <div className='col-12 p-0 p-md-2 col-md-4'>
                    <button 
                        className='btn border w-100' 
                        onClick={() => setOpenModal(false)}
                    >انصراف</button>
                </div>
                <div className='col-12 p-0 p-md-2 col-md-8 mt-2 mt-md-0 font-new-cert'>

                    {accept ? 
                        <button 
                            className='btn new-cert-button' 
                            style={{"background" : "#930000",width : isDesktop ? "fit-content" : "100%"}}
                            onClick={AccpetRule}
                            disabled={isSubmitted}
                            >ابطال گواهی قبلی و دریافت گواهی جدید</button>
                        
                    :
                        <button 
                            disabled
                            className='btn new-cert-button' 
                            style={{"background" : "#7f7d7ddb",width : isDesktop ? "fit-content" : "100%"}}
                        >ابطال گواهی قبلی و دریافت گواهی جدید </button>
                    }
                </div>
            </div>

            {isSubmitted && (
                <div className="loading-overlay">
                <div className="loading-content">
                    <div className="spinner"></div>
                    <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                </div>
                </div>
            )}
        </Box>

    )
}